/**
 * Attaches a character counter element after the given input/textarea.
 * Updates live on 'input' events. Adds 'char-counter--over' class when over limit.
 *
 * @param {HTMLInputElement | HTMLTextAreaElement} input
 * @param {number} maxLength
 * @returns {{ destroy: () => void }}
 */
export function attachCharCounter(input, maxLength) {
  const counter = document.createElement('span');
  counter.className = 'char-counter';

  function update() {
    const len = input.value.length;
    counter.textContent = `${len} / ${maxLength}`;
    counter.classList.toggle('char-counter--over', len > maxLength);
  }

  update();
  input.addEventListener('input', update);
  input.insertAdjacentElement('afterend', counter);

  return {
    destroy() {
      input.removeEventListener('input', update);
      counter.remove();
    },
  };
}
